export default __webpack_public_path__ + "static/media/youtube.482849da.png";